<router-outlet></router-outlet>

<router-outlet name="print"></router-outlet>